// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"685":"c9c45573","1533":"8de73b6d","2624":"d33d6461","5127":"f602d9f4","6368":"60ee57b2","8747":"fa43b214","8998":"2584e2d5"}[chunkId] + ".chunk.css";
};